export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9521.c5b9830d.jpg";